export default "__VITE_ASSET__18_uqRO6__"